import React from 'react'
import styles from './HeaderWNotification.styles'
import Icons from '../../../../components/icons/Icons'
import Heading from '../../../../components/heading/Heading'
import { HEADING } from '../../../../components/heading/constants/constants'
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook'

export default function HeaderWNotification({
    iconName,
    heading = "",
    headerType = HEADING.H1,
    description = "",
    notifications = []
}) {
    const navigate = useTxNavigate();
    
    const handleNotificationClick = (item) => {
        if(item?.link){
            navigate(item?.link);
        }
    }

    return (
        <div style={styles.container}>

            <div style={styles.header}>

                {iconName && <Icons familyName='vec' iconName={iconName} />}

                <Heading type={headerType} customStyle={styles.statusHeading}>{heading}</Heading>
            </div>

            <span>{description}</span>

            <>
                {notifications.map((item, idx) => (
                    <React.Fragment key={idx}>
                        {item.count !== 0 &&
                            <div style={styles.notification} className='d-flex'>
                                <b style={styles.count}>{item.count < 10 ? `0${item.count}` : item.count}</b>

                                <span>
                                    {item.message}
                                    <b 
                                        style={styles.action} 
                                        onClick={() => handleNotificationClick(item)}
                                        tabIndex="0"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleNotificationClick(item);
                                            }
                                        }}
                                    >{item.action}</b>
                                </span>
                            </div>
                        }
                    </React.Fragment>
                ))}
            </>

        </div>
    )
}   